export default "__VITE_ASSET__372567c2__"